export default __webpack_public_path__ + "static/media/wiki_party.68b2dd43.svg";